const xesCookie = {
    getToken() {
        let token = ''
        if (xesCookie.getCookie('childrenToken')) {
            token = xesCookie.getCookie('childrenToken')
            xesCookie.setCookie('token', token)
        } else {
            token = xesCookie.getCookie('token')
        }
        return token
    },
    getCookie(name) {
        if (document.cookie.length > 0) {
            var start = document.cookie.indexOf(name + "=");
            if (start != -1) {
                start = start + name.length + 1;
                var end = document.cookie.indexOf(";", start);
                if (end == -1) {
                    end = document.cookie.length;
                }
                return unescape(document.cookie.substring(start, end));
            }
        }
        return '';
    },
    setCookie(name, value, day) {
        var d = new Date();
        var expires = "";
        if (day) {
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            expires = "expires=" + d.toUTCString();
        };
        document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires;
    },
    delCookie(name,type) {
        var exdate = new Date(),expiredays = -1;
        exdate.setDate(exdate.getDate() + expiredays);
        var value = xesCookie.getCookie(name);
        if (value) {
            //判断是否跨域
            if (type) {
                document.cookie = name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/;domain=saasz.vdyoo.com";
            } else {
                document.cookie = name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
            }
        }
    },
    getUrlParams(name) {
        var url = window.location.href;

        let params = url.substr(url.lastIndexOf('?') + 1).split('&');
        for (let i = 0; i < params.length; i++) {
            let param = params[i];
            let key = param.split('=')[0];
            let value = param.split('=')[1];
            if (key === name) {
            return value;
            }
        }
    }
}
export default xesCookie



// WEBPACK FOOTER //
// ./src/utils/utils.js